const LDClient = window ? window.LDClient : null

const evaluatedSessionFlags = {};

const fsInspector = {
    type: 'flag-used',
    name: 'fullstory-inspector',
    method: (key, detail) => {
        if (window.FS === undefined || typeof window.FS.getCurrentSessionURL !== 'function') {
            return
        }

        const url = window.FS.getCurrentSessionURL(true)
        if (url === undefined) {
            return
        }

        evaluatedSessionFlags[url] = {
            ...evaluatedSessionFlags[url],
            [key]: detail.value,
        }

        const arrayOfFlags = Object.keys(evaluatedSessionFlags[url]).map(
            (flagKey) => `${flagKey}=${JSON.stringify(evaluatedSessionFlags[url][flagKey], null, 1)}`
        )

        if (typeof window.FS.setVars === 'function') {
            window.FS.setVars('page', { ldflags: arrayOfFlags }, { integration: 'launchdarkly' })
        }
    },
}

const options = { inspectors: [fsInspector] }

class LDClientWrapper {
    constructor() {
        this.client = undefined
    }

    initialize() {
        const clientId = window.apr && window.apr.launch_darkly_client_id ? window.apr.launch_darkly_client_id : '';

        if (LDClient && window.Promise && clientId && !this.client) {
            const anonymousUserContext = {
                kind: 'user',
                anonymous: true,
            }
            this.client = LDClient.initialize(clientId, anonymousUserContext, options);
        }
    }

    close() {
        if (this.client) {
            this.client.close()
        }
    }

    getFeatureFlag(flag, defaultValue = false) {
        if (this.client === undefined) {
            return false
        }
        return this.client.variation(flag, defaultValue);
    }

    isInExperiment(flag) {
        if (this.client === undefined) {
            return false
        }

        const variationDetail = this.client.variationDetail(flag);
        if (variationDetail === undefined) {
            return false
        }

        return variationDetail.reason && variationDetail.reason.inExperiment === true;
    }

    track(event) {
        if (this.client === undefined) {
            return;
        }

        this.client.track(event);
    }
}

const ldClientWrapper = new LDClientWrapper()
export default ldClientWrapper
